import React from 'react';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {Question} from '@/types/campaign';
import BriefField from './BriefField';
import styles from './QuestionsForCreator.module.scss';

interface QuestionsForCreatorProps {
  questions: Question[];
}

function QuestionsForCreator({questions}: QuestionsForCreatorProps) {
  const withBody = questions.filter((q) => q.body);
  if (!withBody.length) {
    return null;
  }

  return (
    <BriefField label={translate('Questions for creator')}>
      <div className={styles.list}>
        {withBody.map((q) => (
          <Body key={q.id} size="md">
            {q.body}
          </Body>
        ))}
      </div>
    </BriefField>
  );
}

export default QuestionsForCreator;
